 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLCH00_FM01_TITLE from '@/components/xhtml/ch00_fm01_title'
 import XHTMLCH00_FM02_COPY from '@/components/xhtml/ch00_fm02_copy'
 import XHTMLCH00_FM03_CON from '@/components/xhtml/ch00_fm03_con'
 import XHTMLCH00_FM04_PRE from '@/components/xhtml/ch00_fm04_pre'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLNOTE from '@/components/xhtml/note'
 import XHTMLWORKS from '@/components/xhtml/works'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHOR from '@/components/xhtml/author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/abtnyup_press",
 			"name" : "xhtml/abtnyup_press",
 			"component" : XHTMLABTNYUP_PRESS
 		},
 		{
 			"path" : "/xhtml/ch00_fm01_title",
 			"name" : "xhtml/ch00_fm01_title",
 			"component" : XHTMLCH00_FM01_TITLE
 		},
 		{
 			"path" : "/xhtml/ch00_fm02_copy",
 			"name" : "xhtml/ch00_fm02_copy",
 			"component" : XHTMLCH00_FM02_COPY
 		},
 		{
 			"path" : "/xhtml/ch00_fm03_con",
 			"name" : "xhtml/ch00_fm03_con",
 			"component" : XHTMLCH00_FM03_CON
 		},
 		{
 			"path" : "/xhtml/ch00_fm04_pre",
 			"name" : "xhtml/ch00_fm04_pre",
 			"component" : XHTMLCH00_FM04_PRE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js